var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPreviewingAd)?_c('iframead'):_c('v-app',{class:{ renderingAd: _vm.isRenderingAd }},[_c('TheHeader'),_c('v-main',[_c('v-container',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('link',{attrs:{"href":"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400&display=swap","rel":"stylesheet"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }